import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  partnersEventsApi,
  partnersEventsApiKeys,
  type PartnerEventBody,
  type PartnerEventResponse,
} from '@/api/routes/partners/partners.events.api';

/** Create (no id) or edit an event. The form owns the error UX (field errors and the inline alert). */
export const usePartnersSaveEvent = (id?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: PartnerEventBody) =>
      (id ? partnersEventsApi.update(id, data) : partnersEventsApi.create(data)).then(
        (res) => res.data,
      ),
    meta: { showUserMessage: false },
    onSuccess: ({ event }: PartnerEventResponse) => {
      queryClient.setQueryData(partnersEventsApiKeys.detail(event.id), event);
      return queryClient.invalidateQueries({ queryKey: partnersEventsApiKeys.all });
    },
  });
};
